export enum ToolbarWidthsFullPageNext {
	XXL = 1200,
	XL = 992,
	L = 768,
	M = 576,
	S = 410,
}
